import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';
import * as moment from 'moment';

export class BusinessContactMessage {
    public id: number = 0;
    public consumerName?: string;
    public dateTheFormWasSubmitted?: moment.Moment;
    public bussinesTheFormWasSubmittedFrom?: string;
    public fullNameCompletedInTheForm?: string;
    public emailCompletedInTheForm?: string;
    public phoneCompletedInTheForm?: string;
    public messageCompletedInTheForm?: string;

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.BusinessContacts;
    }

    public get permissionsIdToCheck(): number {
        return this.id;
    }

    public get created(): moment.Moment | undefined {
        return this.dateTheFormWasSubmitted
            ? this.dateTheFormWasSubmitted.local()
            : undefined;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(
            this,
            json,
            {
                dateTheFormWasSubmitted: moment.utc(json.dateTheFormWasSubmitted),
            });
    }
}
